import { TypedDocumentNode, gql } from '@apollo/client';

import { NBA_PLAY_PRO_COMPETITION_DETAILS_LEADERBOARDSLUG } from '@sorare/core/src/constants/__generated__/routes';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import useQuery from '@sorare/core/src/hooks/graphql/useQuery';

import { MissingCards as DumbMissingCards } from '@sorare/us-sports/src/components/leaderboard/MissingCards';

import {
  MissingCardsForLeaderboard,
  MissingCardsForLeaderboardVariables,
} from './__generated__/index.graphql';

const GET_NUMBER_OF_CARDS = gql`
  query MissingCardsForLeaderboard($slug: String!) {
    nbaLeaderboard(slug: $slug) {
      slug
      ...MissingCards_LeaderboardInterface
      myComposeLineupCards(
        first: 5
        includeUsed: true
        indexInLineup: 0
        cardsInLineupPartial: []
      ) {
        nodes {
          card {
            id
            slug
            rarityTyped
          }
        }
      }
    }
  }
  ${DumbMissingCards.fragments.LeaderboardInterface}
` as TypedDocumentNode<
  MissingCardsForLeaderboard,
  MissingCardsForLeaderboardVariables
>;

type Props = {
  leaderboardSlug: string;
};

export const MissingCards = ({ leaderboardSlug }: Props) => {
  const { currentUser } = useCurrentUserContext();
  const { data } = useQuery(GET_NUMBER_OF_CARDS, {
    variables: { slug: leaderboardSlug },
    fetchPolicy: 'network-only',
    skip: !currentUser?.slug,
  });

  if (!data?.nbaLeaderboard || data.nbaLeaderboard.isUserEligible) {
    return null;
  }

  const owned = data.nbaLeaderboard.myComposeLineupCards.nodes.map(c => {
    return c.card.rarityTyped;
  });

  const nbCardsRequirement = 5;

  return (
    <DumbMissingCards
      owned={[
        ...owned,
        ...new Array(Math.max(nbCardsRequirement - owned.length, 0)).fill(
          undefined
        ),
      ]}
      leaderboard={data.nbaLeaderboard}
      nbCardsRequirement={nbCardsRequirement}
      competitionDetailBaseLink={
        NBA_PLAY_PRO_COMPETITION_DETAILS_LEADERBOARDSLUG
      }
    />
  );
};
